<template>
  <div class="solp-grid-box">
    <div class="solp-matrix-display" :class="{'solp-matrix-display--on': on}">
      <div class="solp-msg" :class="`solp-msg--${msg.length}-chars`" v-if="on">{{ msg }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatrixDisplay',
  props: {
    msg: String,
    on: Boolean
  }
}
</script>

<style scoped lang="scss">
  $text-color: #2ed4ba;
  .solp-grid-box {
    white-space: nowrap;
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    //perspective: 400px;
    //border: 1px solid red;
    height: 11.1111%;
  }

  .solp-matrix-display {
    width: 50%;
    background: #00001f;
    padding: 10px 0;
    height: 35px;
    overflow: hidden;
    border-radius: 7px;
    position: relative;
    z-index: 100;
    //transform: rotateY(45deg);
  }

  .solp-msg {
    font-family: DotSpot;
    text-transform: uppercase;
    color: lighten($text-color, 25%);
    text-shadow: 0 0 20px $text-color, 0 0 20px $text-color, 0 0 10px $text-color, 0 0 6px $text-color, 0 0 6px $text-color;
    font-size: 25px;
    transform: translateX(100%);
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    line-height: 15px;
  }

  @for $i from 1 through 300 {
    .solp-msg--#{$i}-chars {
      animation-duration: $i*0.25s;
      animation-name: scroll-#{$i};
    }

    @keyframes scroll-#{$i} {
      from {
        transform: translateX(100%);
      }

      to {
        transform: translateX(-$i*13.572px);
      }
    }
  }
</style>
